import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    padding: 0,
  },
  title: {
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: neutral['100'],
    border: `1px solid ${neutral['20']}`,
  },
  list: {
    border: `1px solid ${neutral['20']}`,
    '&:hover': {
      backgroundColor: neutral['10'],
    },
  },
  listText: {
    marginLeft: '0.5rem',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: neutral['100'],
  },
});
